








































import { Vue, Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import MyMixin from '@/mixins/mixins';
import Banner from '@/components/Banner.vue';
import BottomTabbar from './components/BottomTabbar.vue';
import * as config from './config';
import { appShare, wxShareInfo } from '@/common/ts/common';
import { getBaseinfo } from '@/api/api';
import { Popup } from 'vant';
import Loading from '../Loading.vue';
import Music from './components/Music.vue';
Vue.use(Popup);
@Component({
  components: {
    Banner,
    BottomTabbar,
    Loading,
    Music,
  },
  mixins: [MyMixin],
})
export default class Home extends Vue {
  option = config.OPTHINES;
  bannerSrc = '';
  showModal = false;
  pageLoading = false;
  async created() {
    this.pageLoading = true;
    const res = await getBaseinfo(this.option.voteName);
    this.bannerSrc = res.data.banner;
    // 分享
    this.$appShareInfo({
      title: '2017-2018年度富民兴渝贡献奖评选',
      url: window.location.href,
      subtitle: '选出您心中的“城市英雄”',
      classId: -1,
      id: -1,
      image: this.bannerSrc,
      type: 3,
    });
    this.$wxShareInfo({
      title: '2017-2018年度富民兴渝贡献奖评选',
      subtitle: '选出您心中的“城市英雄”',
      image: this.bannerSrc,
    });
    this.$addPv(374);
  }
  mounted() {
    const preloadImage = this.$refs.preloadImage as HTMLImageElement;
    preloadImage.addEventListener('load', () => {
      setTimeout(() => {
        this.pageLoading = false;
      }, 2500);
    });
  }
  // 活动规则
  showInstructions() {
    this.showModal = true;
  }
}
